import { computed, watch, inject } from "vue";
import { DpaIdCollabGraphqlUsePrependToFolderList } from "@dpa-connect/dpa-id-collab";
import store from "../store";
import mapEventsToListItems from "@/utils/collaboration";

export default function useAddToList() {
  const eventBus = inject<any>("eventBus");

  const {
    data,
    execute,
    fetching,
    done,
    error
  } = DpaIdCollabGraphqlUsePrependToFolderList();

  // @ts-ignore
  const collaboration = computed(() => store.state.collaboration);
  const selectedFolder = computed(() => collaboration.value.selectedFolder);

  function addToList() {
    const items = mapEventsToListItems(collaboration.value.selectedEvents);
    execute({
      folderId: selectedFolder.value.id,
      folderListId: selectedFolder.value.content.id,
      newFolderItems: items,
      sourceApp: "dpa-select"
    });
  }

  watch(fetching, val => {
    if (!val && done.value) {
      store.commit("collaboration/clearSelection");
      store.commit("collaboration/openSidebar");
      eventBus.$emit("sidebarRefresh");
      eventBus.$emit("appMessage", {
        model: true,
        text: "Zur Mappe hinzugefügt"
      });
    } else if (!val && error.value) {
      eventBus.$emit("appMessage", {
        model: true,
        text: "Element konnte nicht hinzugefügt werden."
      });
    }
  });

  return { data, addToList, fetching, done };
}
